import { partnerService } from "@/_services";
export const partner = {
  namespaced: true,
  state: {
    entity: {
      data: {},
      status: {},
    },
    solucion: {
      data: {},
      status: {},
    },
    rma: {
      data: {},
      status: {},
    },
  },
  mutations: {
    partnerSolucionRequest(state) {
      state.solucion.status = {
        solving: true,
      };
    },
    partnerSolucionError(state, error) {
      state.solucion.data = null;
      state.solucion.status = {
        error,
      };
    },
    partnerSolucionSuccess(state, res) {
      state.solucion.data = res;
      state.solucion.status = {
        solved: true,
      };
    },
    partnerRMARequest(state) {
      state.rma.status = {
        solving: true,
      };
    },
    partnerRMAError(state, error) {
      state.rma.data = null;
      state.rma.status = {
        error,
      };
    },
    partnerRMASuccess(state, res) {
      state.rma.data = res;
      state.rma.status = {
        solved: true,
      };
    },
    getPartnerByCodeRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getPartnerByCodeError(state, error) {
      state.entity.data = null;
      state.entity.status = {
        error,
      };
    },
    getPartnerByCodeSuccess(state, res) {
      state.entity.data = res;
      state.entity.status = {
        loaded: true,
      };
    },
  },
  actions: {
    partnerSolucion({ commit }, req) {
      commit("partnerSolucionRequest");
      partnerService
        .partnerSolucion(req.id, req.body)
        .then((res) => {
          commit("partnerSolucionSuccess", res);
        })
        .catch((error) => {
          commit("partnerSolucionError", error);
        });
    },
    partnerRMA({ commit }, req) {
      commit("partnerRMARequest");
      partnerService
        .partnerRMA(req.id, req.tk, req.body)
        .then((res) => {
          commit("partnerRMASuccess", res);
        })
        .catch((error) => {
          commit("partnerRMAError", error);
        });
    },
    getPartnerByCode({ commit }, code) {
      commit("getPartnerByCodeRequest");
      partnerService
        .getPartnerByCode(code)
        .then((res) => {
          commit("getPartnerByCodeSuccess", res);
        })
        .catch((error) => {
          commit("getPartnerByCodeError", error);
        });
    },
  },
};
